import { render } from "./connected-apps.vue?vue&type=template&id=55dd2c9f"
import script from "./connected-apps.vue?vue&type=script&lang=js"
export * from "./connected-apps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__